import * as z from 'zod'

import { ApiModel } from './core'

export enum TypePayment {
  CARD = 'CARD',
  QR = 'QR',
}

const schema = z.object({
  terminalId: z.number(),
  customerId: z.number(),
})

export type BalanceRefillAttributes = z.infer<typeof schema>

export class BalanceRefill extends ApiModel<
  typeof schema,
  BalanceRefillAttributes
> {
  static jsonApiType = 'balance-refill'

  static schema = schema

  static async getFormMeta(): Promise<BalanceRefill> {
    const url = `${BalanceRefill.getJsonApiUrl()}/form-meta`
    const response = await BalanceRefill.effectiveHttpClient.get(url)
    const data = response?.getData()
    return new BalanceRefill(data, data.customerId)
  }

  static async getPaymentUrl(
    amount: number,
    typePayment: TypePayment,
  ): Promise<string> {
    const url = `${BalanceRefill.getJsonApiUrl()}/get-payment-url`
    const response = await BalanceRefill.effectiveHttpClient.post(url, {
      amount,
      typePayment,
    })
    const data = response?.getData()

    return data?.url
  }
}
